import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {ExpensePolicy} from 'main/stores/expenses';
import {AvatarList} from 'shared/components';
import {InteractiveTable} from 'main/components';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const Name = observer(({model}) => {
  return (
    <div className='table-cell align-middle'>
      {model.name || <FormattedMessage id='expenses.manage.policies.Untitled policy'/>}
    </div>
  );
});

const Employees = observer(({model}) => {
  return (
    <div>
      {!_.isEmpty(model.employees) && <AvatarList
        size='sm'
        moreModalEnabled
        employees={model.employees}
      />}
      <div className={`${!_.isEmpty(model.employees) ? 'mt1' : ''} jumbo`}>
        <FormattedMessage
          id='employee_count'
          values={{count: model.employees.length}} />
      </div>
    </div>
  );
});

const COLUMNS = [
  {
    header: 'expenses.manage.Policy Name',
    width: 4,
    component: Name
  },
  {
    header: 'expenses.manage.Approvers',
    width: 4,
    component: ({model}) => model.approvers.map(approver => approver.name).join(', ')
  },
  {
    header: 'expenses.manage.Employees',
    width: 3,
    component: Employees
  }
];

const LOCALIZATION = {
  removeModal: {
    header: 'expenses.manage.Remove Policy',
    body: 'expenses.manage.This cannot be undone. All employees under this policy will be removed from it and have their expense requests deleted.'
  },
  interactive: {
    addModel: 'expenses.manage.Create New Policy'
  }
};

const PolicyDirectory = observer(({uiState}) => {
  return (
    <InteractiveTable
      title={t('expenses.manage.Policies')}
      uiState={uiState}
      columns={COLUMNS}
      saveStateToUrl={true}
      searchable={false}
      onMount={agent => uiState.setInteractiveAgent(agent)}
      localization={LOCALIZATION}
      onAdd={() => uiState.createPolicy()}
      onRemove={policy => uiState.removePolicy(policy)}
      editRoute='/manage/policies/:id/edit'
      proxy={{
        type: 'async',
        modelType: types.EXPENSES.POLICY,
        model: ExpensePolicy,
        endpoint: endpoints.EXPENSES.POLICIES.ALL
      }}>
    </InteractiveTable>
  );
});

export default PolicyDirectory;
